import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('surveys', 'exportToPDF');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'pdf_results',
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
  ],
  options: { responseType: 'blob' },
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/exportToPDF.js